import React from "react";
import { useNavigate } from "react-router-dom";

const ServiceCard = ({ image, title, description, link }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    if (link && link !== "#") {
      // Use React Router navigation for internal routes
      if (link.startsWith("/")) {
        navigate(link);
      } else {
        // External links still use window.location
        window.location.href = link;
      }
    }
  };

  return (
    <div onClick={handleClick} className="block w-full h-full cursor-pointer">
      <div
        className="relative rounded-xl overflow-hidden shadow-lg group w-full h-full cursor-pointer hover:shadow-xl transition-shadow duration-300"
        style={{
          minHeight: "320px",
          maxHeight: "380px",
          height: "100%",
        }}
      >
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 py-4 pl-6 pr-8 text-left">
          <div
            className="h-[50px] flex items-center"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <h3
              className="text-white !font-montserrat font-bold !text-lg leading-tight w-full"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "flex",
                alignItems: "center",
                maxHeight: "48px",
              }}
            >
              {title}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
